// extracted by mini-css-extract-plugin
export default {"light":"styles_light__5bH0h","followCard":"styles_followCard__VrNuF","name":"styles_name__qERnI"};